module.exports = __webpack_public_path__ + "img/bottomSon.c71e5814.svg";